import React from 'react';
import PropTypes from 'prop-types';
import Link from 'react-toolbox/lib/link';
import { Tooltip } from '../styles';

export default class TooltipLink extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    icon: PropTypes.string,
    tooltip: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
    showTooltip: PropTypes.bool,
  };

  constructor() {
    super();

    this.state = {
      isTooltipActive: false,
    };

    this.updateState = this.updateState.bind(this);
  }

  updateState(value) {
    const { showTooltip = true } = this.props;
    if (showTooltip) {
      this.setState({ isTooltipActive: value });
    }
  }

  render() {
    const { label, icon, tooltip, onClick, showTooltip, ...rest } = this.props;
    return (
      <div style={{ position: 'relative' }}>
        <Tooltip active={this.state.isTooltipActive}>
          <span>
            {tooltip}
          </span>
        </Tooltip>
        <Link
          label={label}
          icon={icon}
          active
          onClick={() => {
            this.updateState(true);
            onClick();
          }}
          onMouseEnter={() => this.updateState(true)}
          onMouseLeave={() => this.updateState(false)}
          {...rest}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/RegistrationCard/RegistrationForm/GuestList/TooltipLink.js